var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 71,
    viewBox: "0 0 101 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    fill: "#F4F7FB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9E0",
    d: "M.006 36.144L.003 36 81.245 36c1.55 0 2.708.278 3.686.801.977.523 1.745 1.29 2.268 2.268.523.978.801 2.136.801 3.686v.49c0 1.55-.278 2.708-.801 3.686-.523.977-1.29 1.745-2.268 2.268-.978.523-2.136.801-3.686.801l-78.158.001C1.186 45.758.093 41.074.006 36.144zM32.755 16h56.49c1.55 0 2.708.278 3.686.801.977.523 1.745 1.29 2.268 2.268.523.978.801 2.136.801 3.686v.49c0 1.55-.278 2.708-.801 3.686-.523.977-1.29 1.745-2.268 2.268-.978.523-2.136.801-3.686.801h-56.49c-1.55 0-2.708-.278-3.686-.801-.977-.523-1.745-1.29-2.268-2.268-.523-.978-.801-2.136-.801-3.686v-.49c0-1.55.278-2.708.801-3.686.523-.977 1.29-1.745 2.268-2.268.978-.523 2.136-.801 3.686-.801zM61.755 56h32.49c1.55 0 2.708.278 3.686.801.977.523 1.745 1.29 2.268 2.268.523.978.801 2.136.801 3.686v.49c0 1.55-.278 2.708-.801 3.686-.523.977-1.29 1.745-2.268 2.268-.978.523-2.136.801-3.686.801h-32.49c-1.55 0-2.708-.278-3.686-.801-.977-.523-1.745-1.29-2.268-2.268-.523-.978-.801-2.136-.801-3.686v-.49c0-1.55.278-2.708.801-3.686.523-.977 1.29-1.745 2.268-2.268.978-.523 2.136-.801 3.686-.801z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDropdown);
export default __webpack_public_path__ + "static/media/empty-dropdown.a50a5b64.svg";
export { ForwardRef as ReactComponent };